var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"iq-footer bg-dark"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('ul',{staticClass:"list-inline mb-0"})]),_c('div',{staticClass:"col-lg-6 text-right"},[_vm._v(" Copyright 2023 helexium Todos los derechos reservados. ")])])])])
}]

export { render, staticRenderFns }